<script setup lang="ts">
import LoadingGif from "@/assets/loading-800.gif";
import type { ProgressBarComponentProps } from "@/components/ProgressBarComponent/ProgressBarComponent.vue";
import ProgressBarComponent from "@/components/ProgressBarComponent/ProgressBarComponent.vue";

interface TaiFullPageLoaderComponentProps {
  showLoading: boolean;
  message?: string;
  progressBarOptions?: ProgressBarComponentProps;
}
const { showLoading, message, progressBarOptions } =
  defineProps<TaiFullPageLoaderComponentProps>();
</script>

<template>
  <div
    data-testid="tai-full-page-loader"
    v-if="showLoading"
    class="w-screen h-screen fixed top-0 left-0 bg-white bg-opacity-60 !z-[9999] !pointer-events-auto"
  >
    <div class="h-full flex items-center justify-center px-6">
      <div
        v-if="progressBarOptions"
        class="bg-white p-12 rounded-lg flex flex-col items-center gap-2"
      >
        <div class="w-full sm:w-[600px]">
          <ProgressBarComponent v-bind="progressBarOptions" />
        </div>
        <p
          class="text-system-dark-grey text-center md:max-w-[420px]"
          v-if="message"
        >
          {{ message }}
        </p>
      </div>
      <div v-else class="bg-white p-12 rounded-lg flex flex-col items-center">
        <img class="img-fluid" :src="LoadingGif" width="200" />
        <p
          class="text-system-dark-grey text-center md:max-w-[420px]"
          v-if="message"
        >
          {{ message }}
        </p>
      </div>
    </div>
  </div>
</template>
